import styled, { css } from 'styled-components';
import { breakpoints, colors, font, spacing } from '@chegg-ui/theme';
import SaleBadge from '../SaleBadge/SaleBadge';
export var Banner = styled.div.withConfig({
  componentId: "sc-1vkz9y3-0"
})(["background:", ";height:", ";width:100%;display:flex;align-items:center;justify-content:", ";font-size:", ";font-style:normal;font-weight:700;margin-bottom:", ";margin-top:", ";padding-left:", ";@media (max-width:", "){height:auto;margin-bottom:", ";padding:", ";}"], colors.yellow100, function (_ref) {
  var compact = _ref.compact;
  return compact ? '65px' : '100px';
}, function (_ref2) {
  var compact = _ref2.compact;
  return compact ? 'left' : 'center';
}, function (_ref3) {
  var compact = _ref3.compact;
  return compact ? font.size.px18 : font.size.px26;
}, function (_ref4) {
  var compact = _ref4.compact;
  return compact ? spacing.px8 : spacing.px64;
}, function (_ref5) {
  var compact = _ref5.compact;
  return compact ? spacing.px32 : 0;
}, function (_ref6) {
  var compact = _ref6.compact;
  return compact ? spacing.px24 : 0;
}, breakpoints.lg.min, spacing.px16, spacing.px8);
export var TextContainer = styled.div.withConfig({
  componentId: "sc-1vkz9y3-1"
})(["display:flex;", ";@media (max-width:", "){flex-direction:column;}"], function (_ref7) {
  var compact = _ref7.compact;
  return compact && css(["flex-direction:column;"]);
}, breakpoints.lg.min);
export var StyledLimitedTimeOfferText = styled.span.withConfig({
  componentId: "sc-1vkz9y3-2"
})(["color:", ";padding-right:", ";"], colors.orange900, spacing.px8);
export var StyledRemainingText = styled.span.withConfig({
  componentId: "sc-1vkz9y3-3"
})(["color:", ";"], colors.grey900);
export var StyledSaleBadge = styled(SaleBadge).withConfig({
  componentId: "sc-1vkz9y3-4"
})(["margin-top:", ";font-size:", ";margin-right:", ";position:relative;@media (max-width:", "){margin-right:", ";}"], spacing.px4, function (_ref8) {
  var compact = _ref8.compact;
  return compact ? font.size.px12 : font.size.px18;
}, function (_ref9) {
  var compact = _ref9.compact;
  return compact ? spacing.px16 : spacing.px32;
}, breakpoints.lg.min, spacing.px8);
export var StyledSaleBadgePercentageText = styled.span.withConfig({
  componentId: "sc-1vkz9y3-5"
})(["font-size:", ";line-height:", ";"], function (_ref10) {
  var compact = _ref10.compact;
  return compact ? font.size.px28 : font.size.px42;
}, function (_ref11) {
  var compact = _ref11.compact;
  return compact ? 1.2 : 1;
});
export var ConfettiContainer = styled.div.withConfig({
  componentId: "sc-1vkz9y3-6"
})(["position:absolute;top:-137px;left:-137px;width:400px;height:400px;overflow:hidden;"]);
export var SaleBadgeContainer = styled.div.withConfig({
  componentId: "sc-1vkz9y3-7"
})(["", ";"], function (_ref12) {
  var compact = _ref12.compact;
  return compact && css(["position:relative;top:-5px;"]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBannerWithBadge/styled.js
// module id = 3985
// module chunks = 11